import { castEnum } from "../../../../utils/CommonUtils";
import { DocsBlockMode } from "../../../enums/SDKDocBlockMode";
import { DocsBlockBehaviorDataType } from "../../../enums/SDKDocsBlockBehaviorDataType";
import { DocsBlockBehavior } from "./SDKDocsBlockBehavior";
import { DocsBlockItemDefinition } from "./SDKDocsBlockItemDefinition";
import { DocsBlockOnboarding } from "./SDKDocsBlockOnboarding";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlockDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        this.id = model.id;
        this.name = model.name;
        this.description = model.description;
        this.category = castEnum(model.category);
        this.icon = (_a = model.icon) !== null && _a !== void 0 ? _a : null;
        this.documentationLink = (_b = model.documentationLink) !== null && _b !== void 0 ? _b : null;
        this.searchKeywords = (_c = model.searchKeywords) !== null && _c !== void 0 ? _c : [];
        this.item = new DocsBlockItemDefinition(model.item);
        this.behavior = new DocsBlockBehavior(model.behavior);
        this.editorOptions = {
            onboarding: ((_d = model.editorOptions) === null || _d === void 0 ? void 0 : _d.onboarding)
                ? new DocsBlockOnboarding(model.editorOptions.onboarding)
                : null,
            newItemLabel: (_g = (_f = (_e = model.behavior) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f.newItemLabel) !== null && _g !== void 0 ? _g : null,
        };
        this.appearance = {
            isBordered: (_j = (_h = model.appearance) === null || _h === void 0 ? void 0 : _h.isBordered) !== null && _j !== void 0 ? _j : true,
            hasBackground: (_l = (_k = model.appearance) === null || _k === void 0 ? void 0 : _k.hasBackground) !== null && _l !== void 0 ? _l : false,
            isEditorPresentationDifferent: (_o = (_m = model.appearance) === null || _m === void 0 ? void 0 : _m.isEditorPresentationDifferent) !== null && _o !== void 0 ? _o : false,
            showBlockHeaderInEditor: (_q = (_p = model.appearance) === null || _p === void 0 ? void 0 : _p.showBlockHeaderInEditor) !== null && _q !== void 0 ? _q : false,
        };
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Helpers
    get blockMode() {
        var _a;
        if (this.behavior.dataType === DocsBlockBehaviorDataType.item) {
            if (((_a = this.behavior.items) === null || _a === void 0 ? void 0 : _a.numberOfItems) === 1) {
                return DocsBlockMode.singleItem;
            }
            return DocsBlockMode.multipleItems;
        }
        return DocsBlockMode.data;
    }
    toRemote() {
        return this;
    }
}
